define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitLicenseStatusDomain = void 0;
    class PermitLicenseStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: PermitLicenseStatusDomain.Draft, value: "Draft" },
                    { key: PermitLicenseStatusDomain.PendingApproval, value: "Pending Approval" },
                    { key: PermitLicenseStatusDomain.Approved, value: "Approved" },
                    { key: PermitLicenseStatusDomain.Refused, value: "Refused" },
                    { key: PermitLicenseStatusDomain.Cancelled, value: "Cancelled" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[PermitLicenseStatusDomain.Draft] = 0;
                this.KeyIndex[PermitLicenseStatusDomain.PendingApproval] = 1;
                this.KeyIndex[PermitLicenseStatusDomain.Approved] = 2;
                this.KeyIndex[PermitLicenseStatusDomain.Refused] = 3;
                this.KeyIndex[PermitLicenseStatusDomain.Cancelled] = 4;
                this.ValueIndex = {};
                this.ValueIndex["Draft"] = 0;
                this.ValueIndex["Pending Approval"] = 1;
                this.ValueIndex["Approved"] = 2;
                this.ValueIndex["Refused"] = 3;
                this.ValueIndex["Cancelled"] = 4;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.PermitLicenseStatusDomain = PermitLicenseStatusDomain;
    Object.defineProperty(PermitLicenseStatusDomain, "Draft", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "D"
    });
    Object.defineProperty(PermitLicenseStatusDomain, "PendingApproval", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "PA"
    });
    Object.defineProperty(PermitLicenseStatusDomain, "Approved", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "A"
    });
    Object.defineProperty(PermitLicenseStatusDomain, "Refused", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "R"
    });
    Object.defineProperty(PermitLicenseStatusDomain, "Cancelled", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "CA"
    });
    Object.defineProperty(PermitLicenseStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
